import { captureEvent, useCaptureEvent } from "@Light/app/analytics";
import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { EnrollBottomSheet } from "../common/EnrollBottomSheet";

export type RateExpiredSheetProps = {
  open: boolean;
  onReviewOffer: () => void;
};

export const RateExpiredSheet = ({
  open,
  onReviewOffer,
}: RateExpiredSheetProps) => {
  useCaptureEvent({ event: "rate_expired_shown", condition: open });

  return (
    <EnrollBottomSheet
      open={open}
      onClose={onReviewOffer}
      title="Your rate has expired"
      subtitle="Please review and accept your updated offer to continue."
      data-testid="rate-expired"
      footer={
        <ButtonFooter>
          <Button
            size="lg"
            className="w-full"
            onClick={() => {
              captureEvent("rate_expired_review_offer_clicked");
              onReviewOffer();
            }}
            data-testid="review-offer-button"
          >
            Review offer
          </Button>
        </ButtonFooter>
      }
    />
  );
};
